import { getConfig, getConfigValueOrThrow } from '../config';
import { emitEvent } from '../utils/events/module';
import { Logger } from '../utils/logging/module';
import { clearCurrentSession } from './cache';
import { refreshSession } from './module';
const L = new Logger('SESSION TIMERS');
/**
 * Token refresh timeout
 */
let refreshTimer;
/**
 * Token expire timeout
 */
let expiryTimer;
export function setTimers() {
    // Default autoRefresh to true if it's not defined
    const autoRefresh = getConfig().AUTH_AUTO_REFRESH !== false;
    if (refreshTimer) {
        L.log('Resetting refresh timer...');
        clearTimeout(refreshTimer);
    }
    if (autoRefresh) {
        refreshTimer = setTimeout(() => {
            L.log('Attempting to refresh session...');
            refreshSession();
        }, getConfigValueOrThrow('AUTH_EXPIRY_MS'));
    }
    // Set timeout for when session expires
    L.log('Resetting expiry timer...');
    expiryTimer && clearTimeout(expiryTimer);
    expiryTimer = setTimeout(() => {
        L.log('Session expired!');
        clearCurrentSession();
        emitEvent('session', 'expired');
    }, 
    // 10 seconds after it should have been refreshed
    // That should be enough time to make the API call and reset this timer
    getConfigValueOrThrow('AUTH_EXPIRY_MS') + 10 * 1000);
}
export function clearTimers() {
    if (refreshTimer) {
        clearTimeout(refreshTimer);
        L.log('Refresh timer cleared');
    }
    if (expiryTimer) {
        clearTimeout(expiryTimer);
        L.log('Expiry timer cleared');
    }
}
